export default __webpack_public_path__ + "static/media/pattern8.1ad20da4.png";